const NODE_OUTAGE = 15;
const REDE_EXTERNA_PROBLEMA = 16;
const BACKBONE_MDU_PROBLEMA_SAR = 17;
let FALTA_TAP_PASSIVO_LOTADO = 18;
const PREDIO_SEM_BACKBONE = 19;
const NAP_LOTADA_MDU = 20;
const FALTA_NAP_LOTADA = 21;
const BACKBONE_GPON_PROBLEMA = 22;
const NODE_NAO_LIBERADO = 23;
const RUA_NAO_CABEADA = 24;
const RUA_NAO_CABEADA_GPON = 25;
const SERVICO_CONCLUIDO_MDU = 26;
const EQUIPAMENTO_ROUBADO = 27;
const INSTALACAO_NAO_CONTEMPLA_PADRAO = 28;
const AREA_RISCO_BLOQUEIO_ENDERECO = 29;

export {
  AREA_RISCO_BLOQUEIO_ENDERECO,
  BACKBONE_GPON_PROBLEMA,
  BACKBONE_MDU_PROBLEMA_SAR,
  EQUIPAMENTO_ROUBADO,
  FALTA_NAP_LOTADA,
  FALTA_TAP_PASSIVO_LOTADO,
  INSTALACAO_NAO_CONTEMPLA_PADRAO,
  NAP_LOTADA_MDU, NODE_NAO_LIBERADO,
  NODE_OUTAGE, PREDIO_SEM_BACKBONE,
  REDE_EXTERNA_PROBLEMA,
  RUA_NAO_CABEADA,
  RUA_NAO_CABEADA_GPON,
  SERVICO_CONCLUIDO_MDU
};

